<template>
  <div class="contentCenter all">
    <LoadingSpinner v-if="loadingStats" />
    <div v-else class="table-responsive">
      <div class="alert-info p-4" v-if="isBdrUser">
        <ul class="list-group">
          <li>{{ this.$t("lang.bdr.info.info_1") }}</li>
          <li>{{ this.$t("lang.bdr.info.info_2") }}</li>
          <li>{{ this.$t("lang.bdr.info.info_3") }}</li>
          <li>{{ this.$t("lang.bdr.info.info_4") }}</li>
        </ul>
      </div>
      <div
        class="pb-4 max-content"
        v-if="hasPermissions('superAdmin')"
      >
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsPerVatType"
          :statsDate="statsDate"
          :showTotal="showTotal('ChargedPerVat')"
          :statsTypeText="statsPerVatText"
        />
      </div>
      <div
        class="pb-4 max-content"
        v-if="hasPermissions('adminClients') && !hasPermissions('superAdmin')"
      >
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType1Agency"
          :statsDate="statsDate"
          :showTotal="showTotal('Charged_without_vat')"
          :statsTypeText="statsType1Text"
        />
      </div>
      <div class="pb-4 max-content" v-if="hasPermissions('superAdmin')">
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType8"
          :statsDate="statsDate"
          :statsTypeText="statsType8Text"
        />
      </div>
      <div class="pb-4 max-content" v-if="hasPermissions('superAdmin')" >
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType1"
          :statsDate="statsDate"
          :showTotal="showTotal('Charged')"
          :statsTypeText="statsType1Text"
        />
      </div>
      <div class="pb-4 max-content" v-if="hasPermissions('superAdmin')">
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType2"
          :statsDate="statsDate"
          :showTotal="showTotal('Uncharged')"
          :statsTypeText="statsType2Text"
        />
      </div>
      <div class="pb-4 max-content">
        <UsageStatsTable
          v-if="hasPermissions('superAdmin')"
          :statsClient="statsClient"
          :statsType="statsType3"
          :statsDate="statsDate"
          :showTotal="showTotal('Planned')"
          :statsTypeText="statsType3Text"
        />
      </div>
      <div class="pb-4 max-content" v-if="hasPermissions('superAdmin')">
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType5"
          :statsDate="statsDate"
          :showTotal="showTotal('Declined')"
          :statsTypeText="statsType5Text"
        />
      </div>
      <div class="pb-4 max-content" v-if="hasPermissions('superAdmin')">
        <UsageStatsTable
          :statsClient="statsClient"
          :statsType="statsType7"
          :statsDate="statsDate"
          :showTotal="showTotal('Absent')"
          :statsTypeText="statsType7Text"
        />
      </div>
      <!-- <div class="pb-4">
        <UsageStatsTable
          v-if="hasPermissions('adminClients')"
          :statsClient="statsClient"
          :statsType="statsType4"
          :statsDate="statsDate"
          :onlyTotal="true"
        />
      </div> -->

      <div class="pb-4 max-content"  v-if="hasPermissions('superAdmin')">
        <UsageStatsTable
          v-if="showThisMonth"
          :statsClient="statsClientAgency"
          :statsType="statsType6"
          :statsDate="statsThisMonth"
          :thisMonth="true"
          :statsTypeText="statsType6Text"
        />
      </div>
      <div class="pb-4 max-content">
        <StatsTable
          v-if="!hasPermissions('adminClients')"
          :statsClient="statsClient"
          :statsType="statsTypeBDR"
          :statsDate="statsDate"
          :showTotal="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { statusBadgeMixin, urlMixin, logoMixin } from "@/_mixins/";
import { billingsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import UsageStatsTable from "@/components/Usages/UsageStatsTable.vue";
import StatsTable from "@/components/Usages/StatsTable.vue";
import { monitorService } from "@/_services";

export default {
  data() {
    return {
      loadingStats: false,
      showTotals: [
        {
          item: "ChargedPerVat",
          subtotal: false,
          total: true,
        },
        {
          item: "Charged_without_vat",
          subtotal: true,
          total: false,
        },
        {
          item: "Charged",
          subtotal: true,
          total: false,
        },
        {
          item: "Uncharged",
          subtotal: true,
          total: true,
        },
        {
          item: "Planned",
          subtotal: false,
          total: true,
        },
        {
          item: "Declined",
          subtotal: true,
          total: true,
        },
        {
          item: "Absent",
          subtotal: true,
          total: true,
        },
      ],
      fee: null,
      stats: {},
      statsClient: {},
      statsClientAgency: {},
      statsDate: [],
      statsThisMonth: [],
      showThisMonth: false,
      statsPerVatType: [
        "per_vat_not_charged",
        "per_vat_charged",
      ],
      statsPerVatText: [
        "Charged No V.A.T.",
        "Charged V.A.T.",
      ],
      statsType: [
        "charged",
        "charged_without_vat",
        "subscription_charged_without_vat",
        "uncharged",
        "declined",
        "planned",
        "absent",
        "canceled",
        "subscription_charged",
        "subscription_declined",
        "subscription_uncharged",
        "subscription_exonerated",
        "subscription_canceled",
        "vat"
      ],
      statsType1Agency: [
        "charged_without_vat",
        "subscription_charged_without_vat",
      ],
      statsType1Text: ["Charged leads", "Charged Subscriptions", "Sub-total 1"],

      statsType1: ["charged", "subscription_charged"],
      statsType1Text: ["Charged leads", "Charged Subscriptions", "Charged Developers", "Sub-total 1"],

      statsType2: ["uncharged", "subscription_uncharged"],
      statsType2Text: [
        "Uncharged Leads",
        "Uncharged Subscriptions",
        "Uncharged Developers",
        "Sub-total 2",
        "Total 1+2",
      ],
      statsType3: ["planned"],
      statsType3Text: ["Planned Leads", "Total 1+2+3"],
      statsType4: [
        "charged",
        "uncharged",
        "declined",
        "planned",
        "subscription_charged",
        "subscription_declined",
        "subscription_uncharged",
      ],

      statsType5: [
        "subscription_canceled",
        "declined",
        "subscription_declined",
      ],
      statsType5Text: [
        "Recovery",
        "Declined Leads",
        "Declined Subscription",
        "Sub-total 4",
        "Total 1+2+3+4",
      ],

      statsType6: [
        "new_contact",
        "conversion_rate",
        "total_objective",
        "adjusted_comission",
      ],

      statsType7: ["subscription_exonerated", "absent", "canceled"],
      statsType7Text: [
        "Exonerated",
        "Absent Leads",
        "Canceled Leads",
        "Sub-total 5",
        "Total 1+2+3+4+5",
      ],

      statsType6Text: [
        "Objetive average new contact / day / propspecting client",
        "Objetive conversion rate / propspecting client",
        "Total Objective",
        "Adjusted Comission",
      ],

      statsType8: ["vat"],
      statsType8Text: ["Collected V.A.T"],

      statsTypeBDR: [
        {
          id: "appt",
          label: "Total appointments collected",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "appt_bdr",
          label: "BDR appointments collected",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "revenue",
          label: "BDR appointments revenue",
          format: "amount",
          showQty: false,
          showTotal: false,
        },
        {
          id: "objective",
          label: "BDR impact",
          format: "percentage",
          showQty: false,
          showTotal: false,
        },
        {
          id: "variable",
          label: "BRD impact objective",
          format: "percentage",
          showQty: false,
          showTotal: false,
        },
        {
          id: "adjust",
          label: "Commission on revenue",
          format: "percentage",
          showQty: false,
          showTotal: false,
        },
        {
          id: "commission",
          label: "Adjusted commission value",
          format: "amount",
          showQty: false,
          showTotal: true,
        },
        // {
        //   id: "difference",
        //   label: "appt",
        //   format: "amount",
        //   showQty: false,
        //   showTotal: true,
        // },
      ],
    };
  },

  props: {
    tableType: {
      type: String,
      default: "admin",
    },
  },

  mixins: [statusBadgeMixin, urlMixin, logoMixin],

  components: {
    LoadingSpinner,
    UsageStatsTable,
    StatsTable,
    monitorService,
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
    }),

    showTotal() {
      return (item) => {
        return this.showTotals.find((e) => e.item === item);
      };
    },

    isBdrUser() {
      return (this.currentUser.team_role_id == 2 && this.currentUser.role_id == 2);
    },
  },

  created() {
    if (this.tableType == "admin") {
      this.getAdminStats();
    } else if (this.tableType == "bdr-commissions-real") {
      this.getBDRCommissions();
    }

    if (this.hasPermissions("isReferal")) {
      this.fee = 0.1;
    } else {
      this.fee = 0.1; // agency commission 10%
    }
  },

  methods: {
    getAdminStats() {
      this.loadingStats = true;
      billingsService.getStats().then((response) => {
        if (response) {
          //Calculate subtotals and totals
          let totalSumUncharged = 0;
          let totalSumPlanned = 0;
          let totalSumDeclined = 0;
          let totalSumAbsent = 0;
          let totalSubtotalSumCharged = 0;
          let totalChargedPerVat = 0;
          response.forEach( e => {
            if(this.hasPermissions('isAgencyManager')){
              e.subtotalCharged_without_vat =  (parseFloat(e.charged_without_vat_amount * this.fee) + parseFloat(e.subscription_charged_without_vat_amount * this.fee)).toFixed(0)
            } else {
              e.subtotalCharged =  (parseFloat(e.charged_amount) + parseFloat(e.subscription_charged_amount)).toFixed(0)
              totalSubtotalSumCharged =  totalSubtotalSumCharged + parseInt(e.subtotalCharged);
              e.subtotalCharged = totalSubtotalSumCharged
            }

            totalChargedPerVat = parseFloat(e.per_vat_not_charged_amount) + parseFloat(e.per_vat_charged_amount);
            e.per_vat_not_charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.per_vat_not_charged_amount))) / totalChargedPerVat) * 100).toFixed(1);
            e.per_vat_charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.per_vat_charged_amount))) / totalChargedPerVat) * 100).toFixed(1);
            e.totalChargedPerVat = totalChargedPerVat

            // Uncharged
            e.subtotalUncharged = (parseFloat(e.uncharged_amount) + parseFloat(e.subscription_uncharged_amount)).toFixed(0)
            e.totalUncharged = (parseFloat(e.subtotalCharged) + parseFloat(e.subtotalUncharged)).toFixed(2)

            totalSumUncharged =  totalSumUncharged + parseInt(e.totalUncharged);
            e.totalSumUncharged = totalSumUncharged

            //Planed
            e.totalPlanned = (parseFloat(e.totalUncharged) + parseFloat(e.planned_amount)).toFixed(2)
            totalSumPlanned =  totalSumPlanned + parseInt(e.totalPlanned);
            e.totalSumPlanned = totalSumPlanned

            //Declined
            e.subtotalDeclined =  (parseFloat(e.subscription_canceled_amount) + parseFloat(e.declined_amount) + parseFloat(e.subscription_declined_amount)).toFixed(0)
            e.totalDeclined = (parseFloat(e.totalPlanned) + parseFloat(e.subtotalDeclined)).toFixed(2)
            totalSumDeclined =  totalSumDeclined + parseInt(e.totalDeclined);
            e.totalSumDeclined = totalSumDeclined

            //Absent
            e.subtotalAbsent = (parseFloat(e.subscription_exonerated_amount) + parseFloat(e.canceled_amount) + parseFloat(e.absent_amount)).toFixed(0)
            e.totalAbsent = (parseFloat(e.totalDeclined) + parseFloat(e.subtotalAbsent)).toFixed(2)
            totalSumAbsent =  totalSumAbsent + parseInt(e.totalAbsent);
            e.totalSumAbsent = totalSumAbsent

            e.percentageAbsent = ((e.subtotalAbsent / e.totalAbsent) * 100).toFixed(1)
            e.subscription_exonerated_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_exonerated_amount))) / e.totalAbsent) * 100).toFixed(1);
            e.absent_amount_percentage = ((parseInt(Math.round(parseFloat(e.absent_amount))) / e.totalAbsent) * 100).toFixed(1);
            e.canceled_amount_percentage = ((parseInt(Math.round(parseFloat(e.canceled_amount))) / e.totalAbsent) * 100).toFixed(1);



            e.percentageDeclined = ((e.subtotalDeclined / e.totalDeclined) * 100).toFixed(1)
            e.subscription_canceled_amount_percentage  = ((parseInt(Math.round(parseFloat(e.subscription_canceled_amount))) / e.totalDeclined) * 100).toFixed(1);
            e.declined_amount_percentage = ((parseInt(Math.round(parseFloat(e.declined_amount))) / e.totalDeclined) * 100).toFixed(1);
            e.subscription_declined_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_declined_amount))) / e.totalDeclined) * 100).toFixed(1);

            e.planned_amount_percentage = ((parseInt(Math.round(parseFloat(e.planned_amount))) / e.totalPlanned) * 100).toFixed(1);

            e.percentageUncharged = ((e.subtotalUncharged / e.totalUncharged) * 100).toFixed(1);

            e.uncharged_amount_percentage = ((parseInt(Math.round(parseFloat(e.uncharged_amount))) / e.totalUncharged) * 100).toFixed(1);
            e.subscription_uncharged_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_uncharged_amount))) / e.totalUncharged) * 100).toFixed(1);

            if(this.hasPermissions('isAgencyManager')){
              e.subtotalCharged_without_vat =  (parseFloat(e.charged_without_vat_amount * this.fee) + parseFloat(e.subscription_charged_without_vat_amount * this.fee)).toFixed(1)
            } else {
               e.charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.charged_amount))) / e.subtotalCharged) * 100).toFixed(1);
               e.subscription_charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_charged_amount))) / e.subtotalCharged) * 100).toFixed(1);
            }
          })

          response.forEach( e => {
            if (this.hasPermissions('isAgencyManager')) {
              e.subtotalCharged_without_vat = (parseFloat(e.charged_without_vat_amount * this.fee) + parseFloat(e.subscription_charged_without_vat_amount * this.fee)).toFixed(0)
            } else {
              e.subtotalCharged = (parseFloat(e.charged_amount) + parseFloat(e.subscription_charged_amount)).toFixed(0)
            }

            //Charged
            e.totalSubtotalSumCharged = totalSubtotalSumCharged
            e.percentageCharged = ((e.subtotalCharged / e.totalSubtotalSumCharged) * 100).toFixed(1);

            // Uncharged
            e.subtotalUncharged = (parseFloat(e.uncharged_amount) + parseFloat(e.subscription_uncharged_amount)).toFixed(0)
            e.totalUncharged = (parseFloat(e.subtotalCharged) + parseFloat(e.subtotalUncharged)).toFixed(2)
            e.totalSumUncharged = totalSumUncharged;
            e.percentageTotalUncharged = ((e.totalUncharged / totalSumUncharged) * 100).toFixed(1);


            //Planed
            e.totalPlanned = (parseFloat(e.totalUncharged) + parseFloat(e.planned_amount)).toFixed(2)
            e.totalSumPlanned = totalSumPlanned;
            e.percentageTotalPlanned = ((e.totalPlanned / totalSumPlanned) * 100).toFixed(1);

            //Declined
            e.subtotalDeclined = (parseFloat(e.subscription_canceled_amount) + parseFloat(e.declined_amount) + parseFloat(e.subscription_declined_amount)).toFixed(0)
            e.totalDeclined = (parseFloat(e.totalPlanned) + parseFloat(e.subtotalDeclined)).toFixed(2)
            e.totalSumDeclined = totalSumDeclined;
            e.percentageTotalDeclined = ((e.totalDeclined / totalSumDeclined) * 100).toFixed(1);

            //Absent
            e.subtotalAbsent = (parseFloat(e.subscription_exonerated_amount) + parseFloat(e.canceled_amount) + parseFloat(e.absent_amount)).toFixed(0)
            e.totalAbsent = (parseFloat(e.totalDeclined) + parseFloat(e.subtotalAbsent)).toFixed(2)
            e.totalSumAbsent = totalSumAbsent;
            e.percentageTotalAbsent = ((e.totalAbsent / totalSumAbsent) * 100).toFixed(1);


            e.percentageAbsent = ((e.subtotalAbsent / e.totalAbsent) * 100).toFixed(1)
            e.subscription_exonerated_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_exonerated_amount))) / e.totalAbsent) * 100).toFixed(1);
            e.absent_amount_percentage = ((parseInt(Math.round(parseFloat(e.absent_amount))) / e.totalAbsent) * 100).toFixed(1);
            e.canceled_amount_percentage = ((parseInt(Math.round(parseFloat(e.canceled_amount))) / e.totalAbsent) * 100).toFixed(1);



            e.percentageDeclined = ((e.subtotalDeclined / e.totalDeclined) * 100).toFixed(1)
            e.subscription_canceled_amount_percentage  = ((parseInt(Math.round(parseFloat(e.subscription_canceled_amount))) / e.totalDeclined) * 100).toFixed(1);
            e.declined_amount_percentage = ((parseInt(Math.round(parseFloat(e.declined_amount))) / e.totalDeclined) * 100).toFixed(1);
            e.subscription_declined_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_declined_amount))) / e.totalDeclined) * 100).toFixed(1);

            e.planned_amount_percentage = ((parseInt(Math.round(parseFloat(e.planned_amount))) / e.totalPlanned) * 100).toFixed(1);

            e.percentageUncharged = ((e.subtotalUncharged / e.totalUncharged) * 100).toFixed(1);

            e.uncharged_amount_percentage = ((parseInt(Math.round(parseFloat(e.uncharged_amount))) / e.totalUncharged) * 100).toFixed(1);
            e.subscription_uncharged_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_uncharged_amount))) / e.totalUncharged) * 100).toFixed(1);

            if(this.hasPermissions('isAgencyManager')){
              e.subtotalCharged_without_vat =  (parseFloat(e.charged_without_vat_amount * this.fee) + parseFloat(e.subscription_charged_without_vat_amount * this.fee)).toFixed(1)
            } else {
               e.charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.charged_amount))) / e.subtotalCharged) * 100).toFixed(1);
               e.subscription_charged_amount_percentage = ((parseInt(Math.round(parseFloat(e.subscription_charged_amount))) / e.subtotalCharged) * 100).toFixed(1);
            }
          })



          response.forEach((item) => {
            const client_id = item.client_id;
            const client_name = item.client_name;
            const fdate = item.fdate;

            if (!this.statsDate.find((field) => field.date == fdate)) {
              this.statsDate.push({ date: fdate });
            }
            if (this.statsClient[client_id] == undefined) {
              this.statsClient[client_id] = {};
              this.statsClient[client_id]["name"] = client_name;
            }
            if (this.statsClient[client_id][fdate] == undefined) {
              this.statsClient[client_id][fdate] = item;

              this.statsType.forEach((type) => {
                if (this.statsClient[client_id][type] == undefined) {
                  this.statsClient[client_id][type] = 0;
                  this.statsClient[client_id][type + "_amount"] = 0;
                }
                this.statsClient[client_id][type] += parseFloat(item[type]);
                this.statsClient[client_id][type + "_amount"] += parseFloat(
                  item[type + "_amount"]
                );
              });
            }
          });
          if (this.hasPermissions("isAgencyManager")) {
            // Get data (objetives) to current month
            billingsService.getObjetives().then((res) => {
              //res.fdate = "2022/06"

              //Check if current month's date is present in tthe list of totalmonth result
              const thisMonthFoundOnList = response.find(
                (e) => e.fdate === res.fdate
              );

              let totalTemp = 0;

              if (thisMonthFoundOnList) {
                this.statsType4.forEach((type) => {
                  if (
                    this.statsClient[0][res.fdate][type + "_amount"] !=
                    undefined
                  ) {
                    totalTemp += parseFloat(
                      this.statsClient[0][res.fdate][type + "_amount"]
                    );
                  }
                });

                // agency commission 10%
                const total = parseFloat(totalTemp * 0.1).toFixed(2);
                const subtotal =
                  1 *
                  (res.new_contact / 100) *
                  (res.conversion_rate / 100) *
                  100;
                res.total_objective = subtotal.toFixed(2);
                res.adjusted_comission = ((subtotal * total) / 100).toFixed(0);

                const client_id = res.client_id;
                const client_name = res.client_name;
                const fdate = res.fdate;
                this.statsThisMonth.push({ date: fdate });
                this.statsClientAgency[client_id] = {};
                this.statsClientAgency[client_id]["name"] = client_name;
                this.statsClientAgency[client_id][fdate] = res;

                this.statsType6.forEach((type) => {
                  this.statsClientAgency[client_id][type] = 0;
                  this.statsClientAgency[client_id][type + "_amount"] = 0;
                  this.statsClientAgency[client_id][type] += parseFloat(
                    res[type]
                  );
                  this.statsClientAgency[client_id][type + "_amount"] +=
                    parseFloat(res[type + "_amount"]);
                });
                this.showThisMonth = true;
              }
            });
          }
          this.loadingStats = false;
        }
      });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getBDRCommissions() {
      this.loadingStats = true;
      monitorService
        .getMonitorUser(
          this.currentUser.id,
          "bdr-commissions-real",
          null,
          "month"
        )
        .then((result) => {
          if (result) {
            result.forEach((item) => {
              const client_id = item.client_id;
              const client_name = item.client_name;
              const fdate = item.fdate;

              if (!this.statsDate.find((field) => field.date == fdate)) {
                this.statsDate.push({ date: fdate });
              }
              if (this.statsClient[client_id] == undefined) {
                this.statsClient[client_id] = {};
                this.statsClient[client_id]["name"] = client_name;
              }
              if (this.statsClient[client_id][fdate] == undefined) {
                this.statsClient[client_id][fdate] = item;
                this.statsTypeBDR.forEach((statItem) => {
                  let type = statItem.id;
                  if (this.statsClient[client_id][type] == undefined) {
                    this.statsClient[client_id][type] = 0;
                    this.statsClient[client_id][type + "_amount"] = 0;
                  }
                  this.statsClient[client_id][type] += parseFloat(item[type]);
                  this.statsClient[client_id][type + "_amount"] += parseFloat(
                    item[type + "_amount"]
                  );
                });
              }
            });

            this.loadingStats = false;
          }
        });
    },
  },
};
</script>
<style>
  .max-content {
    width: max-content;
  }
</style>
